var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuestion28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.5 4C8.70101 4 4 8.70101 4 14.5C4 20.299 8.70101 25 14.5 25C20.299 25 25 20.299 25 14.5C25 8.70101 20.299 4 14.5 4ZM3 14.5C3 8.14873 8.14873 3 14.5 3C20.8513 3 26 8.14873 26 14.5C26 20.8513 20.8513 26 14.5 26C8.14873 26 3 20.8513 3 14.5ZM14.5 21.5C15.0523 21.5 15.5 21.0523 15.5 20.5C15.5 19.9477 15.0523 19.5 14.5 19.5C13.9477 19.5 13.5 19.9477 13.5 20.5C13.5 21.0523 13.9477 21.5 14.5 21.5ZM12.5557 9.51735C13.473 9.112 14.5231 8.93609 15.4298 9.0212C16.3487 9.10746 17.024 9.44786 17.3453 9.96785C18.0309 11.0774 17.6311 12.4605 16.2184 13.6575C14.7274 14.9209 14.0006 15.7464 14.0006 17C14.0006 17.2762 14.2245 17.5 14.5006 17.5C14.7768 17.5 15.0006 17.2762 15.0006 17C15.0006 16.2536 15.3558 15.6991 16.8649 14.4205C18.4522 13.0755 19.2604 11.1647 18.196 9.44218C17.6423 8.54616 16.5991 8.12657 15.5232 8.02558C14.4352 7.92344 13.2143 8.13302 12.1515 8.60268C11.899 8.7143 11.7847 9.00954 11.8963 9.26212C12.0079 9.51469 12.3032 9.62896 12.5557 9.51735Z",
  fill: "currentColor"
})));
export default SvgQuestion28;